// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a2e04a05","247":"e7bf6f27","422":"66b46751","627":"47a1356b","653":"4ae73b75","834":"ca7da864","867":"5198e48f","923":"36e1ceb8","938":"5643cde2"}[chunkId] + ".chunk.js";
};